/**
 * Shared Leaflet canvas for vector shapes (polygons, lines, circles, dashes, geodesics).
 * One renderer so hit-testing follows draw order instead of whichever full-map canvas is on top.
 * Above the glify pane, below the default marker pane (600) so pins stay clickable.
 */
export const VECTOR_PANE = 'gpxVectors'

/**
 * WebGL canvases for solid lines and polygon fills.
 * Below {@link VECTOR_PANE} so canvas dashes and circles paint above fills.
 * Those canvases do not take pointer events; the hit router picks glify shapes.
 */
export const GLIFY_PANE = 'gpxGlify'

/** Cluster icons when interactions are on — above {@link VECTOR_PANE}. */
export const INTERACTIVE_MARKER_PANE = 'gpxInteractiveMarkers'

/** HTML divIcon markers when interactions are on — above cluster pane. */
export const INTERACTIVE_HTML_MARKER_PANE = 'gpxInteractiveHtmlMarkers'

/**
 * Shipment track point-cloud dots.
 * z-index 655 — above {@link VECTOR_PANE} (450) so dots paint over path lines,
 * below interactive markers (670) so pins stay on top.
 * The canvas itself has `pointer-events: none`; hits go through the hit router.
 */
export const TRACK_VERTEX_UNDER_MARKERS_PANE = 'gpxTrackVertexUnderMarkers'
